import { fetchApi } from "./fetchApi";

export default {
  async search(statement) {
    return fetchApi({
      data: statement,
      method: "post",
      url: "/api/testPlan/search",
    });
  },
  async historicalTestPlanCount() {
    // Get the total number of test plans that are historically not impacted. Only one record needs to be returned since only the total count is needed.
    const data = {};
    data.filterList = [];
    data.offset = 0;
    data.rowCount = 1;
    data.sortBy = ["releaseNote.id"];
    data.sortDesc = [];

    const historicalStatusFilter = {
      attributeName: "memberTestPlan.status",
      attributeNameLabel: "Testing/Review Status",
      dataType: "string",
      operator: "in",
      operatorLabel: "=",
      value: ["Historically Not Impacted"],
      valueLabel: "Historically Not Impacted",
      valueType: "array",
    };
    data.filterList.push(historicalStatusFilter);

    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/search",
    });

    return response.data.totalCount;
  },
  resetHistoricalTestPlanStatus(serviceAreaId) {
    return fetchApi({
      method: "post",
      url: `/api/testPlan/${serviceAreaId}/setHistoricalTestPlanStatus?resetToNotStarted=true`,
    });
  },
  setHistoricalTestPlanStatus(serviceAreaId) {
    return fetchApi({
      method: "post",
      url: `/api/testPlan/${serviceAreaId}/setHistoricalTestPlanStatus`,
    });
  },
};
